<app-ui-document-panel-shell
  [breadcrumb]="breadcrumb"
  [title]="panelTitle"
  [documentId]="gsn_no || ''"
  [statusLabel]="statusLabel"
  [statusVariant]="statusVariant"
  (closed)="onClose()">

  <app-ui-approval-stepper *ngIf="data?.id" [steps]="approvalSteps"></app-ui-approval-stepper>

  <app-ui-form-section title="General Information" icon="info">
    <div style="display: flex; justify-content: space-between; gap: 30px; flex-wrap: wrap;">
      <div style="flex: 1;" matTooltipPosition="above" [matTooltip]="getCustomerName(customer)">
        <mat-form-field appearance="outline" style="width: auto;">
          <mat-label>Select Customer <span style="color: red">*</span></mat-label>
          <mat-select [(ngModel)]="customer" (openedChange)="onCustomerOpen($event)"
            (ngModelChange)="getCustomerBranch($event)" [disabled]="isUpdateMode" panelClass="customer-select-panel">
            <mat-option disabled class="customer-search-option">
              <input matInput placeholder="Search customer..." (keyup)="onCustomerSearch($event.target.value)"
                (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
            </mat-option>
            <mat-option *ngFor="let item of customerdata" [value]="item.customer_id">
              {{ item.customer_name }}
            </mat-option>
            <mat-option *ngIf="loadingCustomer" disabled>
              Loading…
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div style="flex: 1" matTooltipPosition="above" [matTooltip]="getcustomerBranchName(customer_branch)">
        <mat-form-field appearance="outline" style="width: auto;">
          <mat-label>Customer Branch Name <span style="color:red">*</span></mat-label>
          <mat-select #branchSelect [(ngModel)]="customer_branch" (openedChange)="onBranchOpen($event)"
            (ngModelChange)="fetchso(customer, customer_branch)" panelClass="branch-select-panel" [disabled]="isUpdateMode">
            <mat-option disabled>
              <input matInput placeholder="Search branch..." (keyup)="onBranchSearch($event.target.value)"
                (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
            </mat-option>
            <mat-option *ngFor="let branch of selectedCustomerBranch" [value]="branch.id">
              {{ branch.branch_name }}
            </mat-option>
            <mat-option *ngIf="loadingBranch" disabled>
              Loading…
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div style="flex: 1;" [matTooltip]="getSoName(so)" [matTooltipDisabled]="!isUpdateMode">
        <mat-form-field appearance="outline" style="width: auto;">
          <mat-label>Select Sales Order <span style="color: red">*</span></mat-label>
          <mat-select [(ngModel)]="so" multiple placeholder="Select Sales Order" [disabled]="isUpdateMode" (ngModelChange)="onSoChange($event)">
            <mat-option *ngFor="let item of so_data" [value]="item.id">
              {{ item.so_no }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div style="flex: 1;" [matTooltip]="getBranchName(branch_id)" [matTooltipDisabled]="!isUpdateMode">
        <mat-form-field appearance="outline" style="width: auto;">
          <mat-label>Select Branch<span style="color: red">*</span></mat-label>
          <mat-select [(ngModel)]="branch_id" placeholder="Select Branch" [disabled]="isUpdateMode" (ngModelChange)="onBranchChange()">
            <mat-option *ngFor="let item of filteredBranchData" [value]="item.id">
              {{ item.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div style="flex: 1;" [matTooltip]="getPcCcName(profit_cost_id)" [matTooltipDisabled]="!isUpdateMode">
        <mat-form-field appearance="outline" style="width: auto;">
          <mat-label>Select Profit/Cost Center <span style="color: red">*</span></mat-label>
          <mat-select [(ngModel)]="profit_cost_id" multiple placeholder="Select Profit/Cost Center" [disabled]="isUpdateMode" (ngModelChange)="onProfitCostChange()">
            <mat-option *ngFor="let item of filteredPcCcData" [value]="item.id">
              {{ item.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div style="flex: 1;" [matTooltip]="getSectionName(section_id)" [matTooltipDisabled]="!isUpdateMode">
        <mat-form-field appearance="outline" style="width: auto;">
          <mat-label>Select Section<span style="color: red">*</span></mat-label>
          <mat-select [(ngModel)]="section_id" placeholder="Select Section" [disabled]="isUpdateMode"
            (ngModelChange)="fetchProductList()" multiple>
            <mat-option *ngFor="let item of filteredSectionData" [value]="item.id">
              {{ item.section_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div style="flex: 1;">
        <mat-form-field appearance="outline" style="width: auto;">
          <mat-label>Date<span style="color: red">*</span></mat-label>
          <input type="date" matInput [(ngModel)]="date" class="custom-input" [max]="maxDate" [disabled]="isView || is_reverse" (keydown)="$event.preventDefault()">
        </mat-form-field>
      </div>
    </div>
  </app-ui-form-section>

  <app-ui-form-section title="Line Items" icon="list_alt">
    <p class="ui-doc-panel-table-hint">Scroll inside the table area to view all columns and rows.</p>
    <div class="ui-doc-panel-table-scroll" *ngIf="productList">
      <table class="product-table ui-doc-line-table">
        <thead>
          <tr>
            <th>Profit/Cost Center</th>
            <th>Section</th>
            <th>Line Document No</th>
            <th>Product Service No</th>
            <th>Item/Service Name</th>
            <th>Store</th>
            <th>Description</th>
            <th>HSN/SAC No</th>
            <th>UOM</th>
            <th>Quantity</th>
            <th>Unit Price</th>
            <th>Price</th>
            <th>So Start Date</th>
            <th>So End Date</th>
            <th>Pending Quantity</th>
            <th>Send Qty</th>
            <th *ngIf="is_reverse">Reverse Qty</th>
            <th>Total Price</th>
            <th>Discount Amount</th>
            <th>Incentive Amount</th>
            <th>After Discount/Incentive</th>
            <th>Remark</th>
            <th>Start Date</th>
            <th>End Date</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let product of productList">
            <ng-container *ngIf="product.so_details && product.so_details.length > 0">
              <ng-container *ngFor="let detail of product.so_details; let i = index">
                <ng-container *ngIf="detail?.remaining_qty !== 0">
                  <tr>
                    <td>{{ detail?.profitcost?.name }}</td>
                    <td>{{ detail?.section?.section_name }}</td>
                    <td>{{ detail?.line_document_no }}</td>
                    <td>{{ detail?.product_service_no }}</td>
                    <td class="ui-doc-line-table__wrap">{{ detail?.item_service_type === 'SKU' ? detail?.stock_keeping?.item?.item_name : detail?.service?.service_name }}</td>
                    <td>{{ detail?.store?.store_name }}</td>
                    <td class="ui-doc-line-table__wrap">{{ detail?.description }}</td>
                    <td>{{ detail?.hsn_no }}</td>
                    <td>{{ detail?.unit?.unit_name }}</td>
                    <td>{{ detail?.qty | number:'1.3-3'}}</td>
                    <td>{{ detail?.unit_price  | number:'1.2-2'}}</td>
                    <td>{{ detail?.price  | number:'1.2-2'}}</td>
                    <td>{{ detail?.start_date }}</td>
                    <td>{{ detail?.end_date }}</td>
                    <td>{{ detail?.remaining_qty | number:'1.3-3'}}</td>
                    <td>
                      <input type="text" [(ngModel)]="detail.send_qty" step="0.001" min="0" placeholder="Send Qty" (input)="limitDecimal($event,3);validateSendQty(detail)"
                        (ngModelChange)="getTotalPrice(detail.send_qty,detail.unit_price,detail)" [disabled]="isView || is_reverse" />
                     </td>
                     <td *ngIf="is_reverse">
                       <mat-form-field appearance="outline">
                         <input matInput type="number" [(ngModel)]="detail.reverse_qty" min="0.001" step="0.001"
                           (ngModelChange)="onReverseQtyChange(detail)" (keypress)="allowOnlyNumbers($event)" required>
                       </mat-form-field>
                     </td>
                     <td>
                       <input type="text" [(ngModel)]="detail.gsn_total_price" placeholder="Total Price" (input)="limitDecimal($event,2)"
                         (ngModelChange)="getSentQty(detail.gsn_total_price,detail.unit_price,detail)" [disabled]="isView || is_reverse" />
                     </td>
                     <td>
                       <input type="text" [(ngModel)]="detail.discount_amount" placeholder="Discount"
                       (input)="limitDecimal($event,2); validateDiscountAmount(detail, 'gsn_total_price')"
                       (ngModelChange)="onDiscountIncentiveChange(detail)" [disabled]="isView || is_reverse" />
                    </td>
                     <td>
                      <input type="text" [(ngModel)]="detail.incentive_amount" placeholder="Incentive" (input)="limitDecimal($event,2)"
                        (ngModelChange)="onDiscountIncentiveChange(detail)" [disabled]="isView || is_reverse" />
                      </td>
                    <td style="font-weight: 500;">
                     {{ getLineAdjustmentPrice(detail) | number:'1.2-2' }}
                    </td>
                    <td>
                      <input type="text" [(ngModel)]="detail.remark" placeholder="Remark" [disabled]="isView || is_reverse" />
                    </td>
                     <td>
                       <input type="date" [(ngModel)]="detail.gsn_start_date" style="width: auto;" [disabled]="isView || is_reverse" [min]="detail.start_date" [max]="today" />
                      </td>
                    <td>
                      <input type="date" [(ngModel)]="detail.gsn_end_date" [min]="detail.gsn_start_date" style="width: auto;" [disabled]="isView || is_reverse" />
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="product.details && product.details.length > 0">
              <ng-container *ngFor="let detail of product.details; let i = index">
                <tr>
                  <td>{{ detail?.profit_cost?.name }}</td>
                  <td>{{ detail?.section?.section_name }}</td>
                  <td>{{ detail?.line_document_no }}</td>
                  <td>{{ detail?.product_service_no }}</td>
                  <td class="ui-doc-line-table__wrap">{{ detail?.item_service_type === 'SKU' ? detail?.sku?.item?.item_name : detail?.service?.service_name }}</td>
                  <td>{{ detail?.store?.store_name }}</td>
                  <td class="ui-doc-line-table__wrap">{{ detail?.description }}</td>
                  <td>{{ detail?.hsn_no }}</td>
                  <td>{{ detail?.unit?.unit_name }}</td>
                  <td>{{ detail?.qty | number:'1.3-3' }}</td>
                  <td>{{ detail?.unit_price| number:'1.2-2'}}</td>
                  <td>{{ detail?.price| number:'1.2-2'}}</td>
                  <td>{{ detail?.so_start_date }}</td>
                  <td>{{ detail?.so_end_date }}</td>
                  <td>{{ getInitialTotal(detail) | number:'1.3-3' }}</td>
                  <td>
                    <input type="text" [(ngModel)]="detail.send_qty" step="0.001" min="0" placeholder="Send Qty" (input)="limitDecimal($event,3);validateSendQty(detail)"
                      (ngModelChange)="getTotalPrice(detail.send_qty,detail.unit_price,detail)" [disabled]="isView || is_reverse" />
                  </td>
                  
                  <td *ngIf="is_reverse">
                    <mat-form-field appearance="outline">
                      <input matInput type="number" [(ngModel)]="detail.reverse_qty" min="0.001" step="0.001"
                        (ngModelChange)="onReverseQtyChange(detail)" (keypress)="allowOnlyNumbers($event)" required>
                    </mat-form-field>
                  </td>
                  <td>
                    <input type="text" [(ngModel)]="detail.send_price" placeholder="Total Price" (input)="limitDecimal($event,2)"
                      (ngModelChange)="getSentQty(detail.send_price,detail.unit_price,detail)" [disabled]="isView || is_reverse" />
                  </td>
                  <td>
                    <input type="text" [(ngModel)]="detail.discount_amount" placeholder="Discount" (input)="limitDecimal($event,2)"
                      (ngModelChange)="onDiscountIncentiveChange(detail)" [disabled]="isView || is_reverse" />
                  </td>
                  <td>
                    <input type="text" [(ngModel)]="detail.incentive_amount" placeholder="Incentive" (input)="limitDecimal($event,2)"
                      (ngModelChange)="onDiscountIncentiveChange(detail)" [disabled]="isView || is_reverse" />
                  </td>
                   <td style="font-weight: 500;">
                    {{ getLineAdjustmentPrice(detail) | number:'1.2-2' }}
                  </td>
                  <td>
                    <input type="text" [(ngModel)]="detail.remark" placeholder="Remark" [disabled]="isView || is_reverse" />
                  </td>
                  <td>
                    <input type="date" [(ngModel)]="detail.start_date" [disabled]="isView || is_reverse" [min]="detail.so_start_date" [max]="today"/>
                  </td>
                  <td>
                    <input type="date" [(ngModel)]="detail.end_date" [disabled]="isView || is_reverse" [min]="detail.start_date"/>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
      <tr>
        <td colspan="19" style="text-align: right; font-weight: bold;">Total Discount:</td>
        <td style="font-weight: bold;">{{ getTotalDiscountAmount() | number:'1.2-2' }}</td>
        <td colspan="3"></td>
      </tr>
       <tr>
        <td colspan="19" style="text-align: right; font-weight: bold;">Total Incentive:</td>
        <td style="font-weight: bold;">{{ getTotalIncentiveAmount() | number:'1.2-2' }}</td>
        <td colspan="3"></td>
      </tr>
          <tr>
        <td colspan="19" style="text-align: right; font-weight: bold;">Grand Total Price:</td>
        <td style="font-weight: bold;">{{ getGrandTotal() | number:'1.2-2' }}</td>
        <td colspan="3"></td>
      </tr>
           <tr>
        <td colspan="19" style="text-align: right; font-weight: bold;">Net Adjustment:</td>
        <td style="font-weight: bold;">
          {{ (getGrandTotal() - getDiscountedTotal() >= 0 ? 'Discount: ' : 'Incentive: ') }}
          {{ getNetAdjustment() | number:'1.2-2' }}
        </td>
        <td colspan="3"></td>
      </tr>
    <tr>
        <td colspan="19" style="text-align: right; font-weight: bold;">Discounted Amount:</td>
        <td style="font-weight: bold;">{{ getDiscountedTotal() | number:'1.2-2' }}</td>
        <td colspan="3"></td>
      </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="!productList">
      <p>No data available.</p>
    </div>
  </app-ui-form-section>

  <div style="margin-bottom: 20px;" *ngIf="customer_branch_details">
    <app-ui-form-section title="Customer Branch Details" icon="store">
      <div style="margin-top: 20px; border: 1px solid #000; padding: 10px;width: 50%">
        <table style="width: 100%; border-collapse: collapse; margin-top: 5px;">
          <tr>
            <td style="width: 50%; padding: 5px;"><strong>Branch Name:</strong>{{ customer_branch_details.branch_name || 'NA' }}</td>
            <td style="width: 50%; padding: 5px;"><strong>GST No:</strong>{{ customer_branch_details.gst_number || 'NA' }}</td>
          </tr>
          <tr>
            <td style="width: 50%; padding: 5px;"><strong>Email:</strong>{{ customer_branch_details.email || 'NA' }}</td>
            <td style="width: 50%; padding: 5px;"><strong>Phone:</strong>{{ customer_branch_details.phone || 'NA' }}</td>
          </tr>
          <tr>
            <td style="width: 50%; padding: 5px;"><strong>Address:</strong>{{ customer_branch_details.address || 'NA' }}</td>
          </tr>
        </table>
      </div>
    </app-ui-form-section>
  </div>

  <app-ui-form-section title="Attachments" icon="attach_file">
    <app-ui-document-file-upload
      [disabled]="isInputDisabled"
      [files]="uploadedFiles"
      [showViewLink]="!!data?.id"
      (filesSelected)="onFileSelected($event)"
      (removeFile)="removeFile($event)"
      (viewFiles)="openGsnFileShowModal()">
    </app-ui-document-file-upload>
  </app-ui-form-section>

  <app-ui-form-section title="Remarks" icon="notes">
    <div style="margin-top: 10px;">
      <mat-form-field appearance="fill" style="width: 500px;">
        <mat-label>Remark</mat-label>
        <textarea matInput [(ngModel)]="lumpsum_remark" placeholder="remark" rows="3" [disabled]="isInputDisabled"></textarea>
      </mat-form-field>
    </div>
  </app-ui-form-section>

  <app-ui-document-panel-footer
    [primaryActions]="footerPrimaryActions"
    [secondaryActions]="footerSecondaryActions"
    [destructiveAction]="footerDestructiveAction"
    [overflowActions]="footerOverflowActions"
    (actionClick)="onFooterAction($event)">
  </app-ui-document-panel-footer>

</app-ui-document-panel-shell>
